// Cinematic spotlight beam — used as decorative accent in hero/feature sections.
import React from "react";

export default function Spotlight({
  color = "#E10600",
  width = 800,
  className = "",
  position = "top-left",
  opacity = 0.35,
  blur = 80,
  rotate = -25,
}) {
  const positions = {
    "top-left": { top: "-15%", left: "-10%" },
    "top-right": { top: "-15%", right: "-10%" },
    "bottom-left": { bottom: "-15%", left: "-10%" },
    "bottom-right": { bottom: "-15%", right: "-10%" },
    center: { top: "20%", left: "30%" },
  };

  return (
    <div
      aria-hidden
      className={`absolute pointer-events-none ${className}`}
      style={{
        ...positions[position],
        width: `${width}px`,
        height: `${width * 2}px`,
        background: `conic-gradient(from 0deg at 50% 0%, transparent 0deg, ${color} 8deg, transparent 16deg)`,
        transform: `rotate(${rotate}deg)`,
        filter: `blur(${blur}px)`,
        opacity,
        transformOrigin: "50% 0%",
      }}
    />
  );
}
